export type Attachment = "scroll" | "fixed" | "local" | "initial" | "inherit";

export function isAttachment(value: string): value is Attachment {
    return ["scroll", "fixed", "local", "initial", "inherit"].includes(value);
}
